import { render, staticRenderFns } from "./LeadFlowCommunicationRowMenu.vue?vue&type=template&id=062a9d8c&scoped=true&"
import script from "./LeadFlowCommunicationRowMenu.vue?vue&type=script&lang=js&"
export * from "./LeadFlowCommunicationRowMenu.vue?vue&type=script&lang=js&"
import style0 from "./LeadFlowCommunicationRowMenu.vue?vue&type=style&index=0&id=062a9d8c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "062a9d8c",
  null
  
)

export default component.exports